import { configureStore } from "@reduxjs/toolkit";
import postsReducer from "../store/slices/postsSlice";
import postCategoriesReducer from "../store/slices/postCategoriesSlice";
import exactPostReducer from "../store/slices/exactPostSlice";
import reviewsReducer from "../store/slices/reviewsSlice";
import сategoriesReducer from "../store/slices/сategoriesSlice";
import daysReducer from "../store/slices/daysSlice";
import postOrderReducer from "../store/slices/daysSlice";
import timeReducer from "../store/slices/timeSlice";
import productCategoriesReducer from "../store/slices/productCategoriesSlice";
import cardReducer from "../store/slices/cardSlice";
import productsReducer from "../store/slices/productsSlice";

const store = configureStore({
  reducer: {
    posts: postsReducer,
    postCategories: postCategoriesReducer,
    exactPost: exactPostReducer,
    reviews: reviewsReducer,
    categories: сategoriesReducer,
    days: daysReducer,
    postOrder: postOrderReducer,
    time: timeReducer,
    card: cardReducer,
    productCategories: productCategoriesReducer,
    products: productsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
